export default "__VITE_ASSET__ffd091ac__"